import { render, staticRenderFns } from "./ReceiveQuotation.vue?vue&type=template&id=7619bb9e&"
import script from "./ReceiveQuotation.vue?vue&type=script&lang=js&"
export * from "./ReceiveQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports